"use client";
import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { MdMoreHoriz } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function PartnerDatatableMenu({ row, onDelete }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const show = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return (
    <div className="partner-menu">
      <button
        type="button"
        className="partner-action-button"
        onClick={handleClick}
        aria-label="Partner actions"
        aria-expanded={show}
      >
        <MdMoreHoriz className="keyboardArrowDownIcon-color" size={35} />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={show}
        onClose={handleClose}
        anchorOrigin={{ vertical: "center", horizontal: "left" }}
        transformOrigin={{ vertical: "center", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: { width: 130 },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            navigate(`/view-partner/${row._id}`);
            handleClose();
          }}
          className="menu-datatable-text"
        >
          <RemoveRedEyeIcon className="me-2" fontSize="small" /> View
        </MenuItem>
        <MenuItem
          onClick={() => {
            navigate(`/edit-partner/${row._id}`);
            handleClose();
          }}
          className="menu-datatable-text"
        >
          <BorderColorIcon className="me-2" fontSize="small" /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDelete(row._id, row?.companyName);
            handleClose();
          }}
          className="menu-datatable-text"
        >
          <DeleteIcon className="me-2" fontSize="small" /> Delete
        </MenuItem>
      </Menu>
    </div>
  );
}

export default PartnerDatatableMenu;
